export function removeStackInitiator(stack: string): string {
  const format = stack.includes('    at ') ? 'full' : 'short'
  const parts = stack.split('\n') ?? []
  if (!parts.length) return stack
  if (format === 'full') {
    return [parts[0], ...parts.slice(2)].join('\n')
  }
  return parts.slice(1).join('\n')
}

export function removeErrorStackInitiator(err: Error) {
  const stack = err.stack
  if (!stack) return
  err.stack = removeStackInitiator(stack)
}
